export enum CookieBannerMessageType {
    Favourites = 'Favorites'
}
